import { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "../../../../app/hooks";
import { CONFIRMATION_DELAY } from "../../../../constants/const";
import { getNonceStatus } from "../../../../helper/contractFunctions/MafiaSlotMachine";
import useWallet from "../../../../hook/useWallet";

const useSlotBetChainLink = () => {
  const { account } = useWallet();
  const { currentSlotMachineId } = useAppSelector((state) => state.slot);

  const [isPending, setIsPending] = useState(false);
  const [isFulFilled, setIsFulFilled] = useState(false);

  const fetchUserBetStatus = useCallback(async () => {
    if (!account) return;

    const [isPending, fulfilled] = await getNonceStatus(
      account,
      currentSlotMachineId
    );

    setIsPending(isPending);
    setIsFulFilled(fulfilled);

    return [isPending, fulfilled];
  }, [account, currentSlotMachineId]);

  useEffect(() => {
    // Set up the interval
    const intervalId = setInterval(() => {
      fetchUserBetStatus();
    }, CONFIRMATION_DELAY); // Fetch every 5 seconds (adjust the interval as needed)

    // Clean up the interval on component unmount or dependency change
    return () => clearInterval(intervalId);
  }, [fetchUserBetStatus]);

  return { isPending, isFulFilled };
};

export default useSlotBetChainLink;
